import React from 'react';

const Circle = ({ children }) => {
  return (
    <span className="bdrs-full bg-midnight-90 minw-25 h-25 ta-c mr-24 c-white d-f ai-c jc-c fw-600 fz-18">
      {children}
    </span>
  );
};

export default Circle;
